/**
 * Which stack frame belongs to the method now on screen.
 * Prefer the Call Stack selection, then the live pause, then the first match
 * so recursive same-method frames keep the row the user last chose.
 */
export function pickStackFrameIndexForFlow(matchIndexes, preferredIndex, execIndex) {
    if (!matchIndexes?.length)
        return -1;
    if (matchIndexes.includes(preferredIndex))
        return preferredIndex;
    if (matchIndexes.includes(execIndex))
        return execIndex;
    return matchIndexes[0];
}
